import {
    SpendingReportState,
    SpendingReportConf,
    SpendingTotalByFips,
    SpendingReport_Tab1,
    SpendingReport_Tab2,
    SpendingReport_Tab3,
    SpendingReport_Tab4,
    SpendingReport_AggTab,
    FilterState,
    SpendingReport_Common
} from "../interface/MyInterfaces";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { authHeader } from '../javascript/auth-header';
import { setHeader, setEmployeeAgencyChartText, setExpenditureNationalText, setEmployeeChartText, setCongressText } from './LoadSpendingReportText';
import JSZip from "jszip";
import { saveAs } from 'file-saver';


export function downloadReport(SpendingReportState, FilterState) {
    return dispatch => {

        const zip = new JSZip();
        const chart1Csv = employeeChartText(SpendingReportState);
        const chart2Csv = employeeAgencyChartText(SpendingReportState);
        const chart3Csv = expenditureChartText(SpendingReportState);
        const chart4Csv = congressChartText(SpendingReportState);

        zip.file('chart1.csv', chart1Csv);
        zip.file('chart2.csv', chart2Csv);
        zip.file('chart3.csv', chart3Csv);
        zip.file('chart4.csv', chart4Csv);

        if (SpendingReportState.SpendingJobClassification !== undefined) {
            const chart5Csv = jobClassificationText(SpendingReportState);
            zip.file('chart5.csv', chart5Csv);
        }

        //dispatch(downloadFile(readmeText(FilterState, SpendingReportState), "readme.txt"));
        zip.file('readme.txt', readmeText(FilterState, SpendingReportState));

        zip.generateAsync({ type: "blob" })
            .then(function (blob) {
                saveAs(blob, "SpendingReportData.zip");
            });
    }

}

export function openZoomed(chart_no) {
    return {
        type: "OPEN_ZOOM",
        payload: chart_no
    };
}

export function closeZoomed() {
    return {
        type: "CLOSE_ZOOM",
        payload: 0
    };
}

export function loadSpendingReport(Initial_the_university,display_id, year_type, start_year, end_year, spending_type, work_study, agg, negative, bench_year, bench_schools, agg_schools,vintage,submissionTime) {
    return async dispatch => {

        let x: SpendingReportState = {
            showZoomed: 0,
            SpendingReport_Tab1: { header: "", chart1_text: "" },
            SpendingReport_Tab2: { header: "" },
            SpendingReport_Tab3: { header: "" },
            SpendingReport_Tab4: { header: "" },
            SpendingReport_AggTab: { header: "", chart1_text: "" }
        };
        dispatch({
            type: "SPENDING_REPORT_LOADING",
            payload: x
        });
        let startYear_endYear: FilterState = { start_year: start_year, end_year: end_year }
        let common: SpendingReport_Common = {
            display_id:display_id,
            startYear_endYear: startYear_endYear,
            reportType: (spending_type == "all") ? "federal and non-federal" : "federal",
            reportTypeWithF : (spending_type == "all") ? "Federal and non-federal" : "Federal",
            capitalizedType: (spending_type == "all") ? "Federal and Non-Federal" : "Federal",
            Initial_the_university: Initial_the_university,
            bench_year: bench_year,
            submissionTime
        }
        var bench_school_id = bench_schools.map(x => x.value).join();
        var agg_school_id = agg_schools.map(x => x.value).join();
        var agg_school_names = agg_schools.map(x => x.label).sort().join(', ');
        //also load states here
        dispatch(loadBasicInfo(common, display_id, vintage, year_type, start_year, end_year, spending_type, work_study, agg, bench_year, negative, agg_schools, bench_schools, agg_school_names));        
        dispatch(loadJobClassfication(display_id, start_year, end_year, spending_type, work_study, vintage));
        dispatch(loadEmployeeChart(common, display_id, year_type, start_year, end_year, spending_type, work_study, agg, bench_year, agg_schools, vintage));
        dispatch(loadEmployeeAgencyChart(common, display_id, year_type, start_year, end_year, spending_type, work_study, agg, bench_year, bench_school_id, agg_schools, vintage));
        dispatch(loadReleaseDate(display_id, vintage))
        
        if (agg == 0) {
            dispatch(loadEmployeeTable(display_id, year_type, spending_type, work_study, bench_year, bench_school_id, vintage));
            dispatch(loadExpenditureTable(display_id, year_type, spending_type, work_study, negative, bench_year, bench_school_id, vintage));
            dispatch(loadExpenditureTable2(display_id, year_type, spending_type, work_study, negative, bench_year, bench_school_id, vintage));
            dispatch(loadInStateExpenditureBoxPlot(bench_school_id, spending_type, bench_year, vintage));
            dispatch(loadSummaryTable(display_id, year_type, start_year, end_year, spending_type, work_study, negative, vintage));
        }
    };
}

export function loadStates(common, conf, display_id, year_type, start_year, end_year, spending_type, work_study, agg, bench_year, negative, agg_schools, vintage, bench_schools, agg_school_names) {
    return dispatch => {
        let url = "/IRISReportsMicroservice/api/SpendingReport/states";
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "US_STATES",
                    payload: json
                });

                let state;
                if (json !== undefined && conf !== undefined) {
                    state = json.filter(state => state.statecode === conf.state_fips).length>0? json.filter(state => state.statecode === conf.state_fips)[0].statename : undefined;
                } else {
                    state = "...loading";
                }
                common.state_name = state;

                dispatch(setHeader(common, conf.universities_count, bench_schools, agg_schools, agg_school_names, conf.agg_description, conf.methodology_text, conf.title, conf.change_description, conf.universities_list));
                dispatch(loadExpenditureMap(common, json, display_id, year_type, start_year, end_year, spending_type, work_study, 0, bench_year, negative, agg_schools, vintage));
            });
    };
}

export function loadReleaseDate(display_id, vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/SpendingReport/get_spending_release_date/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SPENDING_RELEASE",
                    payload: json['release_date']
                })
            });
    };
}

export function loadSummaryTable(
    display_id,
    year_type,
    start_year,
    end_year,
    spending_type,
    work_study,
    negative,
    vintage
) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/summary_table/" +
            display_id +
            "/" +
            year_type +
            "/" +
            start_year +
            "/" +
            end_year +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            negative +
            "/" +
            vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SPENDING_SUMMARY_TABLE",
                    payload: json[0]
                });
            });
    };
}
export function loadInStateExpenditureBoxPlot(bench_school_id, spending_type, bench_year,vintage) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/instate_expenditure_boxplot/" +
            bench_school_id +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            bench_year +
            "/" +
            vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                
                dispatch({
                    type: "SPENDING_INSTATE_EXPENDITURE_BOXPLOT",
                    payload: json
                });
            });
    };
}
export function loadExpenditureTable2(
    display_id,
    year_type,
    spending_type,
    work_study,
    negative,
    bench_year,
    bench_school_id,
    vintage
) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/expenditure_table2/" +
            display_id +
            "/" +
            year_type +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            negative +
            "/" +
            bench_year +
            "/" +
            bench_school_id +
            "/" +
            vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SPENDING_EXPENDITURE_TABLE2",
                    payload: json[0]
                });
            });
    };
}
export function loadExpenditureTable(
    display_id,
    year_type,
    spending_type,
    work_study,
    negative,
    bench_year,
    bench_school_id,
    vintage
) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/expenditure_table/" +
            display_id +
            "/" +
            year_type +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            negative +
            "/" +
            bench_year +
            "/" +
            bench_school_id +
            "/" +
            vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SPENDING_EXPENDITURE_TABLE",
                    payload: json[0]
                });
            });
    };
}
export function loadEmployeeAgencyTable(
    display_id,
    year_type,
    spending_type,
    work_study,
    bench_year,
    bench_school_id,
    start_year,
    end_year,
    vintage
) {
    return dispatch => {
  
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/employee_agency_table/" +
            display_id +
            "/" +
            year_type +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            bench_year +
            "/" +
            bench_school_id +
            "/" +
            start_year +
            "/" +
            end_year +
            "/" +
            vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SPENDING_EMPLOYEE_AGENCY_TABLE",
                    payload: json
                });
            });
        
    };
}
export function loadEmployeeTable(
    display_id,
    year_type,
    spending_type,
    work_study,
    bench_year,
    bench_school_id,
    vintage
) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/employee_table/" +
            display_id +
            "/" +
            year_type +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            bench_year +
            "/" +
            bench_school_id +
            "/" +
            vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SPENDING_EMPLOYEE_TABLE",
                    payload: json
                });
            });
    };
}
export function loadCongressMap(
    common,
    states_list,
    spending_total_by_fips,
    display_id,
    year_type,
    start_year,
    end_year,
    spending_type,
    work_study,
    agg,
    bench_year,
    negative,
    mapped_text,
    vintage
) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/congress_map/" +
            display_id +
            "/" +
            year_type +
            "/" +
            start_year +
            "/" +
            end_year +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            agg +
            "/" +
            bench_year +
            "/" +
            negative +
            "/" +
            vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SPENDING_CONGRESS_MAP",
                    payload: json
                });

                dispatch(setCongressText(json, states_list, spending_total_by_fips,common,mapped_text))
            });
    };
}

export function loadExpenditureMap(
    common,
    states_list,
    display_id,
    year_type,
    start_year,
    end_year,
    spending_type,
    work_study,
    agg,
    bench_year,
    negative,
    agg_schools,
    vintage
) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/expenditure_map/" +
            display_id +
            "/" +
            year_type +
            "/" +
            start_year +
            "/" +
            end_year +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            agg +
            "/" +
            bench_year +
            "/" +
            negative +
            "/" +
            vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('data request failed');
                }
                return response.json();

            })
            .then(function (json) {

                let results = json;
                var spending_total_by_fips: SpendingTotalByFips[] = [];
                results.map(x => {
                    var the_index = spending_total_by_fips.findIndex(y => y.tablename == x.tablename && y.fips == x.fips);
                    if (the_index === -1) {
                        spending_total_by_fips.push({ tablename: x.tablename, fips: x.fips, statecode: x.statecode, total: x.total })
                    }
                });
                if (agg == 0) {
                    var mapped_text;
                    var total_mapped = spending_total_by_fips.filter(x => x.fips != 0).map(y => y.total).reduce((prev, next) => +prev + +next);
                    var total = spending_total_by_fips.map(y => y.total).reduce((prev, next) => +prev + +next);
                    mapped_text = (total_mapped / total) * 100;
                    mapped_text = (mapped_text).toFixed(0);

                    dispatch({
                        type: "SPENDING_TOTAL_BY_FIPS",
                        payload: spending_total_by_fips
                    })
                    dispatch({
                        type: "SPENDING_EXPENDITURE_MAP",
                        payload: json
                    });
                    if (common != null) {
                        dispatch(setExpenditureNationalText(json, spending_total_by_fips, common, 0, mapped_text, agg_schools));

                        //load congress map and text
                        dispatch(loadCongressMap(common, states_list, spending_total_by_fips, display_id, year_type, start_year, end_year, spending_type, work_study, agg, bench_year, negative, mapped_text, vintage));
                    }
                }
                else {
                    dispatch({
                        type: "SPENDING_TOTAL_BY_FIPS_AGGREGATE",
                        payload: spending_total_by_fips
                    })
                    dispatch({
                        type: "SPENDING_EXPENDITURE_MAP_AGGREGATE",
                        payload: json
                    });
                    if (common != null)
                        dispatch(setExpenditureNationalText(json, spending_total_by_fips, common, 1, "", agg_schools));
                }
            });
    };
}
export function loadEmployeeAgencyChart(
    common,
    display_id,
    year_type,
    start_year,
    end_year,
    spending_type,
    work_study,
    agg,
    bench_year,
    bench_school_id,
    agg_schools,
    vintage
) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/employee_agency_chart/" +
            display_id +
            "/" +
            year_type +
            "/" +
            start_year +
            "/" +
            end_year +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            agg +
            "/" +
            bench_year +
            "/" +
            vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                //this is populated here
                if (agg == 0) {
                    dispatch(
                        loadEmployeeAgencyTable(
                            display_id,
                            year_type,
                            spending_type,
                            work_study,
                            bench_year,
                            bench_school_id,
                            start_year,
                            end_year,
                            vintage
                        )
                    );
                }
                if (agg == 0) {
                    dispatch({
                        type: "SPENDING_EMPLOYEE_AGENCY_CHART",
                        payload: json
                    });
                    if (json.length > 0)
                        dispatch(setEmployeeAgencyChartText(json, common, agg_schools, 0));
                } else {
                    dispatch({
                        type: "SPENDING_EMPLOYEE_AGENCY_CHART_AGGREGATE",
                        payload: json
                    });
                    if (json.length > 0)
                        dispatch(setEmployeeAgencyChartText(json, common, agg_schools, 1));
                }
            });
    };
}
export function loadEmployeeChart(
    common,
    display_id,
    year_type,
    start_year,
    end_year,
    spending_type,
    work_study,
    agg,
    bench_year, agg_schools, vintage
) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/employee_chart/" +
            display_id +
            "/" +
            year_type +
            "/" +
            start_year +
            "/" +
            end_year +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            agg +
            "/" +
            bench_year +
            "/" +
            vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                if (agg == 0) {
                    dispatch({
                        type: "SPENDING_EMPLOYEE_CHART",
                        payload: json
                    });
                    //set report text
                    if (json.length > 0)
                        dispatch(setEmployeeChartText(json, common, 0, agg_schools));
                    
                } else {
                    dispatch({
                        type: "SPENDING_EMPLOYEE_CHART_AGGREGATE",
                        payload: json
                    });
                    //set report text
                    if (json.length > 0)
                        dispatch(setEmployeeChartText(json, common, 1, agg_schools));
                    
                }
                
            });
    };
}

export function loadBasicInfo(common, display_id, vintage, year_type, start_year, end_year, spending_type, work_study, agg, bench_year, negative, agg_schools, bench_schools, agg_school_names) {
    return dispatch => {
        let url =
            `/IRISReportsMicroservice/api/SpendingReport/reportconf/${display_id}/${vintage}`;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SPENDING_BASIC_INFO_LOADING",
                    //payload: json[0]
                    payload: json
                });
                
                common.state_fips = json.state_fips;
                common.university = json.university;
                common.title_with_research = json.title_with_research;
                dispatch(loadStates(common, json, display_id, year_type, start_year, end_year, spending_type, work_study, agg, bench_year, negative, agg_schools, vintage, bench_schools, agg_school_names));
            });
    };
}

export function loadJobClassfication(display_id,
    start_year,
    end_year,
    spending_type,
    work_study,
    vintage) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SpendingReport/job_classification/" + display_id +
            "/" +
            start_year +
            "/" +
            end_year +
            "/" +
            spending_type.substring(0, 3) +
            "/" +
            work_study +
            "/" +
            vintage;


        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "JOB_CLASSIFICATION",
                    payload: json
                });
            });
    };
}

//download file code
export function downloadFile(text, filename) {
    var element = document.createElement('a');

    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
    return {
        type: "DOWNLOAD",
        payload: "download"
    }
}

function readmeText(FilterState, SpendingReportState) {
    const tab1 = SpendingReportState.SpendingReport_Tab1;
    const chart1_chart_title = tab1.chart1_chart_title;
    const chart2_chart_title = tab1.chart2_chart_title;
    const chart3_chart_title = tab1.chart3_chart_title;
    const tab2 = SpendingReportState.SpendingReport_Tab2;
    const chart4_chart_title = tab2.chart1_chart_title;
    var text = "Read Me\n\n";
    text += "Below is a description for each of the included CSV data files.\n\n";
    text += "Chart 1.csv\n\n";
    text += `Chart1.csv contains the values that are used to populate the data in ${chart1_chart_title} of the report.\n\n`;
    text += "Column 1: This is just a row count. It has no bearing on the display of the data in the chart.\n\n";
    text += "Occupation: This is the occupational category into which job titles have been placed. All employee data submitted to IRIS has a corresponding job title included by your university. IRIS classifies those job titles into categories which are used in this report.\n\n";
    text += "Period: This is the time period that is being reported.\n\n";
    text += "Employee_count: This is the count of unique employees within each of the occupational categories for a given period. Employees are not double counted in chart 1.  If an employee has two different job titles and classifications in a given time period IRIS ranks them and selects the job title and category that makes the most sense. Please see the Methodology section of the report for more information about this.";
    text += "\n\nChart 2.csv\n\n";
    text += `Chart2.csv contains the values that are used to populate the data in ${chart1_chart_title} of the report.`;
    text += "\n\nColumn 1: This is just a row count.It has no bearing on the display of the data in the chart.\n\n";
    text += "Agency: This is the federal agency that has been identified as the federal award sponsor for a given award submitted to IRIS.\n\n";
    text += "Occupation: This is the occupational category into which job titles have been placed. All employee data submitted to IRIS has a corresponding job title included by your university. IRIS classifies those job titles into categories which are used in this report.\n\n";
    text += "Employee_count: This is the count of unique employees within each of the occupational categories for a given agency. Employees may be double counted in chart 2.  If an employee works on awards that are tied to different agencies they may be counted once for each agency they can be associated with.\n\n";
    text += `Chart 3.csv\n\nChart3.csv contains the values that are used to populate the data in ${chart3_chart_title.replace('*','')} of the report.\n\n`;
    text += "Column 1: This is just a row count.It has no bearing on the display of the data in the chart.\n\n";
    text += "Fips: This is the FIPS (Federal Information Processing Standard) code assigned to every county where spending activity has been detected by IRIS.\n\n";
    text += "County_Name: This is the actual county name and state in which it can be found.\n\n";
    text += "Payments: This is the total dollar amount of spending that IRIS has detected in a specified county.\n\n";
    text += "Job_Classification.csv\n\nThis file is provided to assist universities in understanding how IRIS classifies the job titles that have been submitted. Only job title records that have a count of more than 10 is included in this csv for privacy purposes, therefore, the total count per Umetrics_occupational_class might not align with the report.\n\n";
    text += "Umetrics_Occupational_Class: This is the classification that has been assigned by IRIS to a given job title.\n\n";
    text += "Submitted_occ_class: If a university has provided their own job classification it will appear here in this column.\n\n";
    text += "Job_Title: This is the submitted job title that came from the university.\n\n";
    text += "Count: This is the number of records that has the specified job title.\n\n";
    text += `Chart 4.csv\n\nChart4.csv contains the values that are used to populate the data in ${chart4_chart_title} of the report.\n\n`;
    text += "Column 1: This is just a row count.It has no bearing on the display of the data in the chart.\n\n";
    text += "Congress_id: IDs comprised of first two digits being the state fips code and last two digits being the district id.\n\n";
    text += "Payments: This is the total dollar amount of spending that IRIS has detected in a specified congress district.\n\n";
    text += "Data Information(chart_1.csv, chart_2.csv, chart3.csv):\n\n";
    text += "Year type: Fiscal\n";
    text += "Time period: " + FilterState.start_year + " - " + FilterState.end_year + "\n";
    text += "Include work study? " + FilterState.work_study + "\n";
    text += "Report type: " + FilterState.report_type + " spending\n\n";
    text += "Data Information(job_classification.csv): All submitted data\n";
    return text;
}

function jobClassificationText(SpendingReportState) {
    var text = "no.,umetrics_occupational_class,submitted_occ_class,job_title,count";
    var reduced = SpendingReportState.SpendingJobClassification;
    
    reduced.forEach((item, index) => {

        text += "\n";
        text += "\"" + (index + 1) + "\""
        text += ","

        text += "\"" + item.umetrics_occupational_class + "\""
        text += ","

        text += "\"" + item.submitted_occ_class + "\""
        text += ","

        text += "\"" + item.job_title + "\""
        text += ","

        text += "\"" + item.count + "\""
    });

    return text;
}
function congressChartText(SpendingReportState) {
    var text = "no.,tablename,congress_id,payment";
    var reduced = SpendingReportState.SpendingCongressMap.reduce((x, y) => x.findIndex(e => e.tablename == y.tablename && e.congress_id == y.congress_id) < 0 ? [...x, y] : x, []);
    reduced.forEach((item, index) => {
        text += "\n";
        text += "\"" + (index + 1) + "\""
        text += ","

        text += "\"" + item.tablename + "\""
        text += ","

        text += "\"" + item.congress_id + "\""
        text += ","

        text += "\"" + item.payment_amt + "\"";
    });
    return text;
}
function expenditureChartText(SpendingReportState) {
    var text = "no.,tablename,fips,county,payment";
    //var reduced = SpendingReportState.SpendingEmployeeAgencyChart.reduce((x, y) => x.findIndex(e => e.occupational_bucket == y.occupational_bucket && e.year == y.year) < 0 ? [...x, y] : x, []);
    var reduced = SpendingReportState.SpendingExpenditureMap.reduce((x, y) => x.findIndex(e => e.tablename == y.tablename && e.fips == y.fips) < 0 ? [...x, y] : x, []);
    reduced.forEach((item, index) => {
        text += "\n";
        text += "\"" + (index + 1) + "\""
        text += ","

        text += "\"" + item.tablename + "\""
        text += ","

        text += "\"" + item.fips + "\""
        text += ","

        text += "\"" + item.countyname + "\""
        text += ","

        text += "\"" + item.total + "\"";
    });
    return text;
}
function employeeAgencyChartText(SpendingReportState) {
    var text = "no.,agency,occupation,employee_count";
    //var reduced = SpendingReportState.SpendingEmployeeAgencyChart.reduce((x, y) => x.findIndex(e => e.occupational_bucket == y.occupational_bucket && e.year == y.year) < 0 ? [...x, y] : x, []);
    var reduced = SpendingReportState.SpendingEmployeeAgencyChart;
    reduced.forEach((item, index) => {
        text += "\n";
        text += "\"" + (index + 1) + "\""
        text += ","

        text += "\"" + item.agy + "\""
        text += ","

        text += "\"" + item.occ + "\""
        text += ","

        text += "\"" + item.count + "\""
    });
    return text;
}
function employeeChartText(SpendingReportState) {
    var text = "no.,occupation,period,employee_count";
    var reduced = SpendingReportState.SpendingEmployeeChart.reduce((x, y) => x.findIndex(e => e.occupational_bucket == y.occupational_bucket && e.year == y.year) < 0 ? [...x, y] : x, []);
    reduced.forEach((item, index) => {
        text += "\n";
        text += "\"" + (index + 1) + "\""
        text += ","

        text += "\"" + item.occupational_bucket + "\""
        text += ","

        text += "\"" + item.year + "\""
        text += ","

        text += "\"" + item.total + "\""
    });
    return text;
}

export function downloadPDFReport(activeTabIndex, reportType) {
    const doc = new jsPDF();
    const node = document.querySelector('.tabcontents');
    let pdfName;
    /*if (reportType === "spending_report") {
        switch (activeTabIndex) {
            case 1:
                pdfName = "spending-report-congressional-map.pdf";
                break;
            case 2:
                pdfName = "spending-report-benchmarking.pdf";
                break;
            case 3:
                pdfName = "spending-report-aggregate.pdf";
                break;
            case 4:
                pdfName = "spending-report-methodology.pdf";
                break;
            default:
                pdfName = "spending-report-firstTab.pdf";
                break;

        }
    } else 
    */
    if (reportType === "vendor_report") {
        switch (activeTabIndex) {
            case 1:
                pdfName = "vendor-report-methodology";
                break;
            case 2:
                pdfName = "vendor-report-match";
                break;
            default:
                pdfName = "vendor-report-profiles";
                break;
        }
    } else {
        switch (activeTabIndex) {
            case 1:
                pdfName = "employee-report-sectors";
                break;
            case 2:
                pdfName = "employee-report-methodology";
                break;
            case 3:
                pdfName = "employee-report-match";
                break;
            default:
                pdfName = "employee-report-geographic";
                break;
        }
    }

    html2canvas(node as HTMLCanvasElement).then(canvas => {
        const img = canvas.toDataURL("image/png");
        const imgWidth = 200;
        const pageHeight = 297;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        let heightLeft = imgHeight;
        let printY = 0;
        const printX = (210 - imgWidth) / 2;
        doc.addImage(img, 'PNG', printX, printY, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
            printY = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(img, 'PNG', printX, printY, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }
        doc.save(pdfName);
    })
}